import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook, faEnvelope } from '@fortawesome/free-solid-svg-icons';

import './contact.css';

const Contact = () => {
  return (
    <div className="giswnauce__contact">
        <div className="giswnauce__contact-container">
            <span className="anchor-contact" id="giswnauce_contact"></span>
            <div className="contact-container_header">
                <p><FontAwesomeIcon icon={faAddressBook} /></p><h1>Kontakt</h1>
            </div>
            <div className="contact-container_subheader">
                <h2>Komitet Organizacyj</h2>
            </div>
            <div className="contact-container_description">
                <a href="mailto:giswnauce.olsztyn@gmail.com" target="_blank" rel="noreferrer"><h3><span><FontAwesomeIcon icon={faEnvelope} /></span>giswnauce.olsztyn@gmail.com</h3></a>
            </div>
            <div className="contact-container_subheader">
                <h2>Faktury i Rozliczenia</h2>
            </div>
            <div className="contact-container_description">
                <h3>lic. Magdalena Bigoszewska</h3>
                <a href="mailto:magdalena.bigoszewska@uwm.edu.pl" target="_blank" rel="noreferrer"><h3><span><FontAwesomeIcon icon={faEnvelope} /></span>magdalena.bigoszewska@uwm.edu.pl</h3></a>
            </div>
        </div> 
    </div>
  )
}

export default Contact